export const LINKEDIN_REGEXP =
  /^(http[s]?:\/\/)?(www\.)?(\w+\.)?linkedin\.com\/(in|pub|public-profile\/in|public-profile\/pub)\/[A-z0-9_-]+\/?.*$/;
